export const tasks = [
  {
    name: 'home',
    handle() {
      return new Promise(resolve => {
        // setTimeout(() => {
        //   console.log('首页需要的执行');
        //   resolve();
        // }, 3000);
        resolve();
      });
    }
  }
];


// WEBPACK FOOTER //
// ./src/pages/line/index.js